<template>
  <div>
    <div class="text-muted small">{{ notification.created_at | formatRelativeDate }}</div>
    <div>
      {{ $tc('notifications.test.oe_reminder', notification.data.tests, { count: notification.data.tests, sender: notification.data.sender || '' }) }}
      <span> {{ $t('system.in') }}</span>
      <span> {{ $t('tasks.log.title') }}</span>
      "{{ notification.data.task.project.title }}"
      <div v-if="notification.data.message" class="text-muted text-formatted mt-1">{{ notification.data.message }}</div>
      <router-link
          :to="{ name: 'Home', query: { client: notification.data.task.project.client, task_id: notification.data.task.id, type: 'doc_collection_tasks' } }"
          v-if="getClient.projectModule"
      >
        {{ $t('system.view') }} {{ $t('tasks.open_tasks') }}
      </router-link>
    </div>
  </div>
</template>

<script>
// An auditor reminded the documentation collection user about the OE testing tests waiting on them (US 9452)
export default {
  name: 'CollectionOeReminder',
  props: {
    notification: {}
  },
  computed: {
    getClient() {
      return this.$store.state.client;
    }
  }
}
</script>
